/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76362ResListItemOtherDataObjDataObjFilesItem {
  
  /** 文件名称 */
  name?: string;
  
  /** 文件地址 */
  url?: string;
  
  /** 文件大小 */
  size?: string;
  
};
    
  
    
export interface IAPI76362ResListItemOtherDataObjDataObj {
  
  /** 数据类型：text|image|video|voice|file */
  dataType?: string;
  
  /** 文件名称 */
  fileName?: string;
  
  /** 文件地址 */
  fileUrl?: string;
  
  /** 文件大小 */
  fileSize?: string;
  
  /** 操作人ID */
  operatorId?: string;
  
  /** 操作人昵称 */
  operatorName?: string;
  
  /** 文件列表 ,OtherDataFileInfo */
  files?: IAPI76362ResListItemOtherDataObjDataObjFilesItem[];
  
};
    
  
    
export interface IAPI76362ResListItemOtherDataObj {
  
  /** 消息类型：annex_file:附件 */
  messageType?: string;
  
  /** 消息详情 ,OtherDataInfo */
  data?: IAPI76362ResListItemOtherDataObjDataObj;
  
};
    
  
    
export interface IAPI76362ResListItemSenderObj {
  
  /** 成员Id */
  userId?: string;
  
  /** 成员名称 */
  userName?: string;
  
  /** 成员头像 */
  userHeadUrl?: string;
  
  /** 真名 */
  realName?: string;
  
  /** 是否逾期 */
  isOverdue?: number;
  
};
    
  
    
export interface IAPI76362ResListItem {
  
  /** 消息唯一ID */
  messageId?: string;
  
  /** 文本内容 */
  content?: string;
  
  /** 发送时间 */
  sendTime?: string;
  
  /** 扩展信息 ,OtherData */
  otherData?: IAPI76362ResListItemOtherDataObj;
  
  /** 发送人信息 ,SendUserResult */
  sender?: IAPI76362ResListItemSenderObj;
  
  /** 是否GTP消息 */
  gpt?: boolean;
  
  /** 发消息人员 */
  fromUser?: string;
  
};
    
  



export interface API76362Req {
  
  /** 业务ID */
  bizNo: string;
  /** 检索内容 */
  queryContent: string;
  /** 数据类型，file|image_video */
  dataType: string;
  /** 开始日期 */
  startDate: string;
  /** 结束日期 */
  endDate: string;
  /** 每几页 */
  pageIndex: string;
  /** 每页尺寸 */
  pageSize: string;
  /** 业务ID */
  bizNo?: string;
  /** 检索内容 */
  queryContent?: string;
  /** 数据类型，file|image_video */
  dataType?: string;
  /** 开始日期 */
  startDate?: string;
  /** 结束日期 */
  endDate?: string;
  /** 每几页 */
  pageIndex?: number;
  /** 每页尺寸 */
  pageSize?: number;
};



export interface API76362Res {
  /** T  */
  list?: IAPI76362ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 76362 分页查询聊天记录（右边）

export interface IUsePostAPI76362Return {
  /** 分页查询聊天记录（右边）: 接口请求状态 */
  isAPI76362Loading: boolean;
  /** 分页查询聊天记录（右边）: 接口请求返回数据 */
  dataAPI76362: API76362Res;
  /**  分页查询聊天记录（右边）: 接口数据请求方法 */
  fetchAPI76362Data: (inputs: API76362Req, config?: YWRequestConfig) => Promise<API76362Res>;
  /** 分页查询聊天记录（右边）: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76362 = ():IUsePostAPI76362Return => {
  let isMount = true;
  const [isAPI76362Loading, setIsAPI76362Loading] = useState(false);
  const [dataAPI76362, setDataAPI76362] = useState<API76362Res>({} as API76362Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/message/search`;

  const fetchAPI76362Data = async (inputs: API76362Req, config?: YWRequestConfig): Promise<API76362Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76362Req>) || {}) as API76362Req;
    
  
    if ( isMount ) {
      setIsAPI76362Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76362Res>(`${basePath}/yoaichat-web/chat/message/search`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76362(res || {} as API76362Res);
        setIsAPI76362Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76362Loading(false);
      }
      return false as unknown as API76362Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76362Loading,
    dataAPI76362,
    fetchAPI76362Data,
    requestUrl,
  }
}

